import { Pipe, PipeTransform } from '@angular/core';
import {
  AttributeValidator,
  AttributeValidatorModel,
  Scope,
} from '@app/shared/interfaces/Attribute';
import { ModelField } from '@app/shared/interfaces/front-end-column';

@Pipe({
  name: 'ValidatorToField',
})
export class ValidatorToFieldPipe implements PipeTransform {
  transform(
    validator: AttributeValidator,
    validatorsModel: AttributeValidatorModel[]
  ): any {
    const val = validatorsModel.find((x) => x.code == validator.ValidatorType);
    if (val == null) {
      return;
    }
    const field: ModelField = {
      Code: val?.code,
      DataType: val?.type,
      Scope: Scope.Global,
      Title: val?.name,
    };
    return field;
  }
}
